import config from './config';

const axios = require('axios');

const webService = axios.create({
    baseURL: config.webUrl,
    withCredentials: true
});
webService.defaults.headers.common['X-CSRF-TOKEN'] = config.token;
export default webService;
